import { Component, Input, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UserContextService, Workspace } from '@sentry/user-context';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatListModule } from '@angular/material/list';

@UntilDestroy()
@Component({
    selector: 'sentry-tool-bar',
    templateUrl: './tool-bar.component.html',
    styleUrls: ['./tool-bar.component.scss'],
    standalone: true,
    imports: [CommonModule, MatToolbarModule, MatButtonModule, MatIconModule, MatMenuModule, MatListModule, RouterModule]
})
export class ToolBarComponent implements OnInit {
  @Input() title = '';

  workspaces: Workspace[] = [];
  currentWorkspace: Workspace | null = null;

  constructor(
    private readonly userContextService: UserContextService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.userContextService.workspaces$
      .pipe(untilDestroyed(this))
      .subscribe((workspaces) => (this.workspaces = workspaces));

    this.userContextService.selectedWorkspace$
      .pipe(untilDestroyed(this))
      .subscribe((workspace) => (this.currentWorkspace = workspace));
  }

  changeWorkspace() {
    this.userContextService.navigateToWorkspaceSelectionPage(this.router);
  }

  navigateToMyTraining(): void {
    if (this.currentWorkspace?.organizationId) {
      this.router.navigate(['/my-org', this.currentWorkspace.organizationId, 'training', 'my-training']);
    }
  }

  logoutClick(): void {
    this.userContextService.logout();
  }
}
